import React from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, Link, TextField } from '@mui/material'
import { useAuth } from '../../hooks/context/UserAuthContext'
import { Link as RouterLink } from 'react-router-dom'

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm({ criteriaMode: 'all' })

  const { login } = useAuth()

  const onSubmit = async (data) => {
    data.email = data.email?.toLowerCase()
    const err = await login(data)
    if (err) {
      setError('email', err)
    }
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box display='flex' flexDirection='column' rowGap={2} justifyContent='space-between'>
        <TextField
          placeholder='example@example.com'
          label='Email address'
          type='email'
          inputProps={{
            inputMode: 'email',
            ...register('email', {
              required: 'Email address is required.',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address.',
              },
            }),
            autoCapitalize: 'none',
            style: { textTransform: 'lowercase' },
          }}
          error={Boolean(errors?.['email'])}
          helperText={errors?.['email']?.message}
        />

        <TextField
          type='password'
          label='Password'
          inputProps={{ ...register('password', { required: 'Password is required.' }) }}
          error={Boolean(errors?.['password'])}
          helperText={errors?.['password']?.message}
        />

        <Link
          textTransform='none'
          component={RouterLink}
          to='/forgot-password'
          disabled={isSubmitting}
        >
          Forgot your password?
        </Link>

        <Button type='submit' variant='contained' disabled={isSubmitting}>
          Submit
        </Button>
      </Box>
    </form>
  )
}

export default LoginForm
